import { IOrderSummaryState } from './orderSummary.types'

export const INITIAL_OUTER_DATA = {
  group_name: 'Overall Orders',
  total_ordered_qty: 0,
  total_pending_qty: 0,
  total_accepted_qty: 0,
  total_rejected_qty: 0,
  total_orders: 0,
  total_pending_orders_value: 0,
  total_orders_value: 0
}

export const DEFAULT_ORDER_SUMMARY_LIMIT = 100

export const OrderSummaryState: IOrderSummaryState = {
  loaders: {
    orderSummary: false,
    groupSummary: false,
    allOrderListLoader: false,
    overallGroupSummary: false
  },
  orderSummaryData: INITIAL_OUTER_DATA,
  groupViewData: null,
  allOrderListData: null,
  activeFilter: null,
  selectedGroupId: null,
  drawers: {
    orderSummaryDownload: false
  },
  overallOrderGroupData: {
    data: [],
    page: 1,
    limit: DEFAULT_ORDER_SUMMARY_LIMIT,
    totalItems: 0
  }
}
